<template>
    <section class="inNewsDetailBox">
        <div class="wrapper">
            <section class="inNewsDetail">
                <div class="title">{{newsDetail.title}}</div>
                <div class="dateAndVisits">
                    <div class="date">
                        <i class="fa fa-clock-o"></i>
                        <span>{{newsDetail.date}}</span>
                    </div>
                    <div class="eyes">
                        <i class="fa fa-eye"></i>
                        <span>{{newsDetail.visits}}</span>
                    </div>
                </div>
                <div class="line"></div>
                <div class="mainbody" v-html="newsDetail.content">
                </div>
            </section>
            <section class="inNewsPageBox">
                <div class="prevNav">
                    <span>Pre</span><router-link :to="`${preInfo.link}`">{{preInfo.title}}</router-link>
                </div>
                <div class="middleIco">
                    <router-link  to="/news">
                        <i class="fa fa-list-ul"></i>
                    </router-link>
                </div>
                <div class="nextNav">
                    <router-link :to="`${nextInfo.link}`">{{nextInfo.title}}</router-link><span>Next</span>
                </div>
            </section>
        </div>
    </section>
</template>

<script>
import { getContent,getList } from '../../../api'
export default {
    data() {
        return {
            newsDetail:{},
            isZhong:false,
            newsListArr:[],
            preInfo:{},
            nextInfo:{}
        };
    },
    created(){
        
        this.getNewsDetail()
    },
    
    methods: {
      async getNewsDetail(){
                const isZhong = this.$parent.isZhong;
                let res2;
                if(isZhong){
                    res2 = await getList(47);
                    
                }else{
                    res2 = await getList(2);
                }
                this.isZhong = isZhong; 
                let newsListArr = res2.data;
                newsListArr = newsListArr.map(v=>{
                    return{
                        id:v.id,
                        date:{
                            day:v.date.slice(8,10),
                            month:v.date.slice(0,7)
                        },
                        title:v.title,
                        visits:v.visits,
                        desc:v.description,
                        imgUrl:v.ico,
                        link:'/news/newsdetail/'+v.id
                    }
                })
                this.newsListArr = newsListArr;

                const contentId = this.$route.params.id;
                const res = await getContent(contentId);
                this.newsDetail = res.data;

                //查到当前id所在位置
                const index = newsListArr.findIndex(v=>v.id==contentId);
                console.log(index)
                let preInfo={};
                let nextInfo={};

                if(index<0 || newsListArr.length<0){
                    preInfo={
                        title:'none',
                        link:'#'
                    },
                    nextInfo={
                        title:'none',
                        link:'#'
                    }
                    return;
                }

                if(index<newsListArr.length-1){
                    nextInfo= newsListArr[index+1];
                }else{
                    nextInfo={
                        title:'none',
                        link:'#'
                    }
                }
                if(index>=1){
                    preInfo = newsListArr[index-1];
                }else{
                    preInfo={
                        title:'none',
                        link:'#'
                    }
                }

                this.preInfo = preInfo;
                this.nextInfo = nextInfo;

            }
    },
    watch:{
        // 方法1
        '$route': function (to, from) { // 监听路由是否变化
            if (this.$route.params.id) { // 判断条件1  判断传递值的变化
                // 获取文章数据
                this.getNewsDetail();
            }
        }

    }
};
</script>

<style lang="scss" scoped>
@import '../../../common/css/mixin.scss';
.inNewsDetailBox {
   background: #fafdfd;  
   padding: 28px 0 66px 0;
}
.inNewsDetail {
   padding: 66px 50px 78px 50px;
   background: #fff;
  .title {
      text-align: center;
      font-size: 24px;
      font-weight: bold;
      line-height: 44px;
  }

  .dateAndVisits {
      height: 52px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 22px;
    .date {
      color: #aaa;
      font-size: 18px;
      i{
      }
      span {
          margin-left: 2px;
      }
    }
    .eyes {
      margin-left: 38px;
      color: #aaa;
      font-size: 18px;
      i{
      }
      span {
          margin-left: 2px;
      }
    }
  }
  .line {
      width: 100%;
      height: 1px;
      background: #ebebeb;
  }
  .mainbody {
      margin-top: 38px;
      line-height: 30px;
      img,video{
          max-width: 100%;
      }  
      img{
          display: inline-block;
      }
  }
}
.inNewsPageBox {
   height: 100px;
   padding: 0 50px;
   background: #fff; 
   @include flexFather;
   margin-top: 12px;
  .prevNav {
    height: 100%;
    @include flexFather;
    span {
        font-size: 16px;
        color: #aaa;
        width: 58px;
    }
    a {
        width: 436px;
        display: block;
        overflow: hidden;
        line-height: 100px;
        height: 100px;
    }
  }
  .middleIco {
    border-left: 1px solid #ebebeb;  
    border-right: 1px solid #ebebeb;  
    width: 98px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    a{
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        i{
            font-size: 22px;
            color: #a8a8a8;
        }
        &:hover{
            background: $themeColor;
            i{
                color: #fff;
            }
        }
    }
    
  }
  .nextNav {
    height: 100%;
    @include flexFather;
    a {
        width: 436px;
        display: block;
        overflow: hidden;
        line-height: 100px;
        height: 100px;
        text-align: right;
    }
    span {
        font-size: 16px;
        color: #aaa;
        width: 58px;
        text-align: right;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/News/NewsDetail/NewsDetail.vue